import Immutable from 'immutable';
import { AlphaColumn } from '../../../reducers/AlphasReducer/AlphasReducer.types';
import { AlphaTabType } from '../../../shared/constants';

interface GetIsColumnAvailableParams {
  column: AlphaColumn;
  alphaOptions: Immutable.Map<string, any> | undefined;
}

export const getIsColumnAvailable = ({ column, alphaOptions }: GetIsColumnAvailableParams) => {
  const parent = column.get('parent');
  if (parent !== 'settings') {
    return true;
  }

  // We don't want to expose columns that are not available in the settings
  const columnParent = alphaOptions?.getIn([parent, 'children']) as Immutable.Map<string, unknown> | undefined;
  return !!columnParent?.get(column.get('id'));
};

interface IsStatusColumnAvailableParams {
  column: AlphaColumn;
  type: string;
}

// Status values are not meaningful in the Unsubmitted table, so the Status column is hidden there
// (both the rendered columns and the "Select Columns" modal). See BRAINTECH-5549.
export const isStatusColumnAvailable = ({ column, type }: IsStatusColumnAvailableParams) =>
  !(column.get('id') === 'status' && type === AlphaTabType.UNSUBMITTED);
